import { render } from "./NewStyledModal.vue?vue&type=template&id=2908c420&scoped=true"
import script from "./NewStyledModal.vue?vue&type=script&lang=js"
export * from "./NewStyledModal.vue?vue&type=script&lang=js"

import "./NewStyledModal.vue?vue&type=style&index=0&id=2908c420&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2908c420"]])

export default __exports__